import { useSelector } from "react-redux";

import { BiDollarCircle } from "react-icons/bi";
import { FaListAlt } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { MdOutlineMenuBook } from "react-icons/md";
import { RiMoneyDollarCircleFill } from "react-icons/ri";

import { ALLOWED_ORGS_FOR_PAYOUT } from "@/constants";

const NavSelector = () => {
  const loggedInOrgId = useSelector((state) => state?.login?.orgDetails?.orgId || "");
  const allowedOrgsForPayout = ALLOWED_ORGS_FOR_PAYOUT;

  const defaultNavItems = [
    {
      name: "Orders",
      icon: FaListAlt,
      path: "/order",
      title: "Order page title",
      customerVisibility: true,
      orgTypeVisibility: true,
    },
    {
      name: "Balances",
      icon: RiMoneyDollarCircleFill,
      title: "Balances",
      path: "/balances/settlement",
      customerVisibility: true,
      collapsable: false,
      orgTypeVisibility: true,
    },
    {
      name: "Users",
      icon: FaUsers,
      title: "Users",
      path: "/users",
      customerVisibility: true,
      collapsable: false,
      orgTypeVisibility: true,
    },
  ];

  if (allowedOrgsForPayout.includes(loggedInOrgId))
    defaultNavItems.push({
      name: "Settlements",
      icon: BiDollarCircle,
      path: "/settlements",
      title: "Settlements",
      customerVisibility: true,
      orgTypeVisibility: true,
      divider: true,
    });

  defaultNavItems.push({
    name: "API Docs",
    icon: MdOutlineMenuBook,
    title: "API Docs",
    path: "/api-docs",
    customerVisibility: true,
    orgTypeVisibility: true,
  });

  return defaultNavItems;
};

export default NavSelector;
